export { Login } from './Login'
export { VerifyEmailAddress } from './VerifyEmailAddress'
export { NotFound } from './NotFound'

import * as licensedAgencyPages from './licensedAgency'
import * as supportPages from './support'

export const Pages = {
  ...licensedAgencyPages,
  ...supportPages,
}
